import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type {
  ExternalProviderRepository,
  SubmitRequestDataBody,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface SubmitRequestDataCommand {
  requestId: string;
  body: SubmitRequestDataBody;
  externalProviderRepository: ExternalProviderRepository;
}

export const submitRequestData = createAsyncThunk<void, SubmitRequestDataCommand>(
  "externalProvider/submitRequestData",
  async ({ requestId, body, externalProviderRepository }: SubmitRequestDataCommand) => {
    return externalProviderRepository.submitRequestData(requestId, body);
  },
);

export const resetSubmitRequestData = createAction("externalProvider/resetSubmitRequestData");
